/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-14 10:23:41
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-18 11:23:55
 * @FilePath: \mrc-ess-fronted\src\mixin\index.js
 */
import btnPermission from "./btnPermission";
export default {
  install(v) {
    v.mixin(btnPermission);
  },
};
